import React, { Component } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

const PhotoResult = React.lazy(() => import("./views/PhotoResults"));
const EventResults = React.lazy(() => import("./views/EventResults"));

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <React.Suspense fallback={loading}>
          <Routes>
            <Route exact path="/" name="PhotoResult" element={<PhotoResult />} />
            <Route exact path="/event/:slug" name="EventResults" element={<EventResults />} />
          </Routes>
        </React.Suspense>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
